import React from 'react'
import logo from '../assets/logowbg.png';
import stalin from '../assets/stalin.jpg';
import tnwclogo from '../assets/tnwclogo.avif';

import wh1 from '../assets/wh1.jpg';
import wh2 from '../assets/wh2.avif';
import wh3 from '../assets/wh3.png';
import wh4 from '../assets/wh4.webp';
import { useEffect, useState } from 'react';
// import './Homepage1.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle';
import {
    FaPhoneAlt, FaEnvelope, FaMapMarkerAlt,
    FaFacebookF, FaInstagram, FaLinkedinIn
} from "react-icons/fa";



function Navbar() {
    return (
        <>
            {/* Top Navbar: Images */}
            <nav className="navbar navbar-expand-lg bg-light shadow-sm py-2">
                <div className="container d-flex justify-content-between align-items-center">
                    <span className="navbar-brand d-flex align-items-center gap-2">
                        <img
                            src={tnwclogo}
                            alt="Tamil Nadu Warehousing Logo"
                            style={{ height: '90px', width: 'auto' }}
                        />

                        <div className="brand-text">
                            <div style={{ fontWeight: '700', fontSize: '0.8rem', color: '#1c1464', lineHeight: 1.1 }}>
                                தமிழ்நாடு சேமிப்புக் கிடங்கு நிறுவனம்
                            </div>
                            <div style={{ fontWeight: '400', fontSize: '0.5rem', color: '#bf4040', marginBottom: '0.25rem' }}>
                                (தமிழ் அரசு சார்பு நிறுவனம்)
                            </div>
                            <div style={{ fontWeight: '700', fontSize: '0.8rem', color: '#1c1464', lineHeight: 1.1 }}>
                                TAMIL NADU WAREHOUSING CORPORATION
                            </div>
                            <div style={{ fontWeight: '400', fontSize: '0.5rem', color: '#bf4040' }}>
                                (A Government of Tamil Nadu Sponsored Undertaking)
                            </div>
                        </div>
                    </span>

                    <span className="navbar-brand d-flex align-items-center gap-2">
                        <img
                            src={logo}
                            alt="Tamil Nadu Warehousing Logo"
                            style={{ height: '90px', width: 'auto' }}
                        />
                        <div className="brand-labels d-flex align-items-end flex-column justify-content-end" >
                            <h6 className="mb-1 fw-bold text-primary">MK STALIN</h6>
                            <p className="mb-0 text-muted small fst-italic" style={{ whiteSpace: 'nowrap', fontSize: '.8rem' }}>
                                Hon’ble Chief Minister Govt. of Tamil Nadu
                            </p>
                        </div>

                        <span className="navbar-brand fw-bold text-primary">
                            <img
                                src={stalin}
                                alt="MK Stalin"
                                className="rounded-circle"
                                style={{ height: '90px', width: '90px', objectFit: 'cover', border: '3px solid #0d6efd' }}
                            />

                        </span>
                    </span>
                </div>
            </nav>

        </>
    );
}

export default Navbar